import React, { SyntheticEvent, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setUser } from '../userSlice';

const Login = () => {
    const [credentials, setCredentials] = useState({
        username: '',
        password: '',
    });
    const [errorMessage, setErrorMessage] = useState('');

    const onChange = (e: any) => {
        setCredentials({
            ...credentials,
            [e.target.name]: e.target.value,
        });
    };

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const url = '/api/login_check';

    const submitHandler = async (e: SyntheticEvent) => {
        e.preventDefault();
        try {
            let response = await axios.post(url, credentials, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            localStorage.setItem('userToken', response.data.token);
            let userUrl = '/api/user_admins?email=' + credentials.username;
            let userInfo = await axios.get(userUrl);
            const user = userInfo.data['hydra:member'][0];
            const isAdmin = user.roles.includes('ROLE_ADMIN');
            localStorage.setItem('userEmail', user.email);
            localStorage.setItem('agencyName', '');
            localStorage.setItem('userId', user.id);
            localStorage.setItem('roles', user.roles);
            localStorage.setItem('isAdmin', isAdmin);
            localStorage.setItem('quota', user.quotaIA);
            localStorage.setItem('isSsoUser', 'false');
            localStorage.setItem('userMyId', '');
            localStorage.setItem('groupement', JSON.stringify(user.groupement));
            localStorage.setItem('autoPublish', 'false');
            dispatch(
                setUser({
                    isAuthenticated: true,
                    isAdmin: isAdmin,
                    id: user.id,
                    email: user.email,
                    agencyName: '',
                    token: response.data.token,
                    quota: user.quotaIA,
                    role: user.roles,
                    isSsoUser: false,
                    userMyId: '',
                    groupement: user.groupement,
                    autoPublish: false,
                }),
            );
            if (user.groupement.id === 1) {
                navigate('/dashboard');
            } else {
                navigate('/dashboard_admin');
            }
        } catch (error: any) {
            if (error.response?.status === 401) {
                setErrorMessage("Nom d'utilisateur ou mot de passe incorrect.");
            }
            console.error(error);
            setErrorMessage("Une erreur s'est produite, veuillez réessayer.");
        }
    };

    return (
        <>
            <form onSubmit={submitHandler} className="w-full max-w-[330px] p-[15px] mx-auto">
                <h1 className="text-super-heavy font-heavy">Se connecter</h1>
                <div className="p-[10px] text-medium h-auto">
                    <label htmlFor="login">Identifiant</label>
                    <input
                        type="email"
                        name="username"
                        className="block w-full leading-[1.5] bg-white rounded border border-[#ced4da]"
                        placeholder=" "
                        value={credentials.username}
                        onChange={onChange}
                    />
                </div>
                <div className="p-[10px] text-medium h-auto">
                    <label htmlFor="password">Mot de passe</label>
                    <input
                        type="password"
                        name="password"
                        className="block w-full leading-[1.5] bg-white rounded border border-[#ced4da]"
                        placeholder=" "
                        value={credentials.password}
                        onChange={onChange}
                    />
                </div>
                {errorMessage && <p className="warning-login">{errorMessage}</p>}
                <div className="p-[10px] text-medium h-auto">
                    <button className="block text-black px-4 py-2 text-medium leading-[1.5] rounded-[1.5rem] w-fit font-medium border border-primary bg-primary items-center content-center justify-center flex-row p-[10px] ">
                        Connexion
                    </button>
                </div>
            </form>
        </>
    );
};

export default Login;
